<template>
  <div class="comp-container__white-board">
    <div
      v-show="!isBoardReady"
      class="white-board-loading-mask"
      tabindex="-1"
      aria-busy="true"
    >
      <div class="white-board-loading-content">
        <i class="el-icon-loading" aria-label="加载中"></i>
        <div class="white-board-loading-text">白板加载中</div>
      </div>
    </div>
    <div v-show="isBoardReady" id="comp-container__white-board-sketch"></div>
    <template v-if="allIsReady && !isRecordPage && !isTransparent">
      <template v-if="showMobileToolbar">
        <!-- 工具栏 -->
        <!-- 手机端工具栏 -->
        <mobile-toolbar
          @on-log="handleLog"
          :isAudioOpen="isAudioOpen"
          :isHorizontal="isHorizontal"
          :isWhiteBoard="isWhiteBoard"
        />
      </template>
      <template v-else-if="isWhiteBoard">
        <toolbar :isMGAppInPad="isMGAppInPad" />
        <!-- 元素工具栏 -->
        <!-- 只有老师可以控制 -->
        <!-- 白板页面控制器 -->
        <div
          v-if="controlPage && whiteboardType === 'whiteboard'"
          class="bottom-controller-wrap"
        >
          <page-controller />
          <scale-controller />
        </div>
        <!-- 只有老师可以控制 -->
        <!-- 课件页面控制器 -->
        <courseware-controller
          :isVideo="isVideo"
          v-if="controlPage && whiteboardType === 'courseware'"
        ></courseware-controller>
      </template>
      <element-toolbar />
    </template>
  </div>
</template>

<script>
import MobileToolbar from "./mobile/MobileToolbar.vue";
import ScaleController from "./components/ScaleController.vue";
import PageController from "./components/PageController.vue";
import ElementToolbar from "./components/ElementToolbar.vue";
import { mapMutations, mapState } from "vuex";
import Toolbar from "./components/Toolbar.vue";
import CoursewareController from "./courseware/CoursewareController.vue";
// import {
//   LiveSet,
//   DragWrap,
//   UploadCourseware,
//   isImage,
//   isVideo,
//   isDoc,
// } from "@saas/components";
const isImage = (fileName) => {
  const reg = /(\.jpg|\.jpeg|\.png|\.gif|\.bmp)$/i;
  return reg.test(fileName);
};
// 根据文件名判断是否是视频
const isVideo = (fileName) => {
  const reg =
    /(\.mp4|\.avi|\.rmvb|\.wmv|\.flv|\.mov|\.mpg|\.mpeg|\.rm|\.asf|\.3gp|\.mkv|\.3g2|\.h264|\.m4v|\.mj2|\.ogg|\.ogv|\.qt|\.vob|\.webm|\.f4v)$/i;
  return reg.test(fileName);
};
// 根据文件名判断是否是文档
const isDoc = (fileName) => {
  const reg = /(\.pdf|\.doc|\.docx|\.ppt|\.pptx|\.xls|\.xlsx)$/i;
  return reg.test(fileName);
};
export default {
  props: {
    isTransparent: {
      type: Boolean,
      default: false,
    }, //白板是否透明
    isAudioOpen: {
      type: Boolean,
      default: true,
    },
    isHorizontal: {
      type: Boolean,
      default: false,
    },
    showMobileToolbar: {
      type: Boolean,
      default: false,
    },
    isImReady: {
      type: Boolean,
      default: false,
    },
    lessonId: {
      type: Number,
      default: 0,
    },
    controlPage: {
      type: Boolean,
      default: false,
    },
    isWhiteBoard: {
      type: Boolean,
      default: false,
    },
    isRecordPage: {
      type: Boolean,
      default: false,
    },
    isMGAppInPad: {
      type: Boolean,
      default: false,
    },
    isHXApp: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Toolbar,
    ElementToolbar,
    PageController,
    ScaleController,
    MobileToolbar,
    CoursewareController,
  },
  data() {
    return {
      isVideo: false,
    };
  },
  computed: {
    ...mapState("live", [
      "whiteBoardService",
      "whiteboardType",
      "roomInfo",
      "imService",
    ]),
    ...mapState("whiteBoard", ["isBoardReady"]),
    allIsReady() {
      return this.isBoardReady && this.isImReady;
    },
    coursewareList() {
      return this.roomInfo.doc || [];
    },
  },
  created() {},
  beforeDestroy() {
    if (this.whiteBoardService && this.whiteBoardService?.off) {
      this.whiteBoardService.off("dataSynced");
      this.whiteBoardService.off("ready");
      this.whiteBoardService.off("tabGotoBoard");
      this.whiteBoardService.off("tabSwitchFile");
      this.whiteBoardService.off("scaleBoard");
      this.whiteBoardService.off("error");
    }
  },
  watch: {
    whiteBoardService: {
      handler(val) {
        if (val) {
          this.init();
        }
      },
      immediate: true,
    },
    isWhiteBoard: {
      handler(val) {
        if (this.whiteBoardService?.setDrawEnable) {
          this.whiteBoardService.setDrawEnable(val);
        }
      },
      immediate: true,
    },
    "roomInfo.isStudent": {
      handler(val) {
        if (this.whiteBoardService?.setVideoControlEnable && val) {
          this.whiteBoardService.setVideoControlEnable(false);
        }
      },
      immediate: true,
    },
    controlPage: {
      handler(val) {
        if (this.isMGAppInPad || this.isHXApp) {
          if (val) {
            this.whiteBoardService?.setVideoControlEnable(true);
          } else {
            this.whiteBoardService?.setVideoControlEnable(false);
          }
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    ...mapMutations("whiteBoard", ["setBoardReady", "setCurrentFileInfo"]),
    ...mapMutations("live", ["setRoomInfo", "setWhiteboardType"]),
    init() {
      this.whiteBoardService.on("dataSynced", (data) => {
        this.$emit("data-synced", data);
        console.log("data-synced", data);
      });
      this.whiteBoardService.on("ready", () => {
        this.setBoardReady(true);
        this.$emit("on-ready");
        this.whiteBoardService.setDrawEnable(this.isWhiteBoard);
        //获取白板当前数据
        this.setCurrentFileInfo(this.whiteBoardService.getFileInfo());
        // 把所有的课件插入到白板
        this.handleInsertCourseware();
        this.getCurrentFileInfo();
        if (this.isMGAppInPad || this.isHXApp) {
          this.whiteBoardService.setVideoControlEnable(this.controlPage);
        } else {
          this.whiteBoardService.setVideoControlEnable(
            !this.roomInfo.isStudent
          );
        }
      });
      this.whiteBoardService.on("error", () => {
        this.$emit("on-error");
      });

      this.whiteBoardService.on("tabGotoBoard", (fid) => {
        this.setCurrentFileInfo(this.whiteBoardService.getFileInfo(fid));
      });

      this.whiteBoardService.on("tabSwitchFile", (fid) => {
        this.setCurrentFileInfo(this.whiteBoardService.getFileInfo(fid));
        this.getCurrentFileInfo();
      });
      this.whiteBoardService.on("scaleBoard", () => {
        this.setCurrentFileInfo(this.whiteBoardService.getFileInfo());
      });
    },
    handleLog(log) {
      this.$emit("on-log", log);
    },
    addSyncData(realtimeData) {
      this.whiteBoardService.addSyncData(realtimeData);
    },
    // 把所有课件插入白板
    handleInsertCourseware() {
      const list = this.coursewareList;
      console.log("list____", list);
      list.forEach((item) => {
        if (item.roomFileId) {
          return;
        }
        let roomFileId = null;
        if (isVideo(item.doc_name)) {
          // 插入视频课件
          roomFileId = this.whiteBoardService.addVideoFile({
            url: item.transcode_result,
            title: item.doc_name,
          });
        } else if (isImage(item.doc_name)) {
          // 插入图片课件
          roomFileId = this.whiteBoardService.addImagesFile({
            urls: [item.transcode_result],
            title: item.doc_name,
          });
        } else {
          // 插入文件课件
          const config = {
            url: item.transcode_result,
            title: item.doc_name,
            pages: item.pages || 1,
            resolution: item.resolution,
          };
          roomFileId = this.whiteBoardService.addTranscodeFile(config, false);
        }
        if (roomFileId) {
          item.roomFileId = roomFileId;
        }
      });
      this.setRoomInfo({ doc: list });
    },
    // 获取当前文件信息
    getCurrentFileInfo() {
      const currentFile = this.whiteBoardService.getFileInfo();
      if (currentFile) {
        this.isVideo = isVideo(currentFile.downloadURL);
        const isWhiteBoard = this.whiteBoardService.isWhiteBoard(
          currentFile.fileType
        );
        if (isWhiteBoard) {
          this.handleUpdateWhiteboardType("whiteboard");
        } else {
          const data = {
            id: this.roomInfo.id,
            fileId: currentFile.fid,
          };
          localStorage.setItem("lastCourseware", JSON.stringify(data));
          this.handleUpdateWhiteboardType("courseware");
        }
      }
    },
    handleUpdateWhiteboardType(type) {
      this.setWhiteboardType(type);
      // this.imService.sendMGLiveRoomCustomMsg({
      //   cmdId: 2,
      //   data: {
      //     type: "whiteboardType",
      //     data: {
      //       type: type,
      //     },
      //   },
      // });
    },
  },
};
</script>

<style scoped lang="scss">
.comp-container__white-board {
  position: relative;
  width: 100%;
  flex: 1;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  min-height: 0; // 防止flex子元素溢出
  #comp-container__white-board-sketch ::v-deep {
    width: 100%;
    height: 100%;
    flex: 1;
    min-height: 0; // 防止内容溢出
    overflow: hidden;
    .tic_board_img_bg {
      width: 100% !important;
      height: 100% !important;
      object-fit: contain;
      object-position: center !important ;
    }
  }
  .bottom-controller-wrap {
    position: absolute;
    right: 20px;
    bottom: 12px;
    display: flex;
    align-items: center;
  }
  .white-board-loading-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: all;
    .white-board-loading-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .white-board-loading-text {
      margin-top: 16px;
      font-size: 14px;
      color: #165dff;
      letter-spacing: 2px;
      text-align: center;
      user-select: none;
    }
    i.el-icon-loading {
      font-size: 48px;
      color: #165dff;
    }
  }
}
</style>
<style>
.comp-container__white-board .tic_board_img_bg {
  width: 100% !important;
}
</style>
